<div>   
    {#if $syncStatus == 'pending'}
    <progress class="progress is-small is-warning" value="100" max="100"></progress>
    {:elseif $syncStatus == 'syncing'}
    <progress class="progress is-small is-success" max="100"></progress>
    {:else}
    <progress class="progress is-small is-success" value="100" max="100"></progress>
    {/if}
</div>
